// extracted by mini-css-extract-plugin
module.exports = {"SplitSection":"SplitSection_SplitSection__2xuta","Works":"SplitSection_Works__bhag7"};